export default "__VITE_ASSET__Cwn8uFBD__"